import { Box, BoxProps, Button, styled as MUIstyled, Typography, CircularProgress } from '@mui/material'
import styled, { css } from 'styled-components'

interface IMessageContainer extends BoxProps {
  error?: boolean
  message?: boolean
}

export const MessageContainer = styled(Box)<IMessageContainer>`
  border: 1px solid transparent;
  display: grid;
  place-content: center;
  border-radius: 4px;
  padding: 5px 10px;
  margin-bottom: 5px;

  ${(props) =>
    props.error &&
    css({
      borderColor: '#d32f2f',
      color: '#d32f2f',
    })}

  ${(props) =>
    props.message &&
    css({
      borderColor: props.theme.customerColor,
      color: props.theme.customerColor,
    })}
`

export const HeaderText = MUIstyled(Typography)`
  font-weight: 600;
  font-size: 1.25rem;
  color: #4e5256;
`
export const Subtitle = MUIstyled(Typography)`
  color: #4e5256;
  margin-bottom: 10px;
  line-height: 1.5rem;
`
export const ExternalLink = styled.a`
  margin: 15px 0;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  line-height: 0.75rem;
  text-align: center;
  text-decoration: underline;
  color: ${({ theme }) => theme.customerColor};
`

export const SubmitButton = MUIstyled(Button)`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1rem;
  padding: 1rem 0;
  margin-top: auto;
`

export const LoadingIcon = MUIstyled(CircularProgress)`
  margin-left: 10px;
  color: white;
  position: absolute;
  right: 20;
`
